import {
  DfyOrderDetailsDto,
  DfySourceImageConfig,
  DfyTemplateType,
} from "@repo/api/dfy";
import { SourceImageDto } from "@repo/api/source-image";
import { DFY_PACKAGE_IMAGE_COUNTS } from "@repo/api/utils/dfy-billing";
export interface DfyOrderImageItem {
  config: DfySourceImageConfig;
  image: SourceImageDto;
}

export type DfyDetailSection = "logo" | "propertyDetails" | "agentDetails";

export const DFY_TEMPLATE_DETAIL_SECTIONS_MAP: Record<
  DfyTemplateType,
  DfyDetailSection[]
> = {
  PROPERTY_INTRO: ["propertyDetails"],
  AGENT_OUTRO: ["agentDetails"],
  LOGO: ["logo"],
};

export function getDfyRequiredImageCount(details: DfyOrderDetailsDto): number {
  return DFY_PACKAGE_IMAGE_COUNTS[details.type];
}

export function isValidDfyListingUrl(value: string): boolean {
  const trimmed = value.trim();
  const withProtocol = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;
  try {
    const { hostname } = new URL(withProtocol);
    return /^([a-z0-9-]+\.)+[a-z]{2,}$/i.test(hostname);
  } catch {
    return false;
  }
}

export function getDfyOrderImageItems(
  details: DfyOrderDetailsDto,
  sourceImages: Record<string, SourceImageDto>,
): DfyOrderImageItem[] {
  return details.sourceImageConfigs
    .map((config) => ({ config, image: sourceImages[config.externalId] }))
    .filter((item): item is DfyOrderImageItem => Boolean(item.image));
}

export function getDfySelectionNumbers(
  items: DfyOrderImageItem[],
): Map<string, number> {
  const selectionNumbers = new Map<string, number>();
  items
    .filter((item) => item.config.isSelected)
    .forEach((item, index) => {
      selectionNumbers.set(item.config.externalId, index + 1);
    });
  return selectionNumbers;
}

export function getDfyRequiredSections(
  details: DfyOrderDetailsDto,
): DfyDetailSection[] {
  if (!details.addOns.branding) {
    return [];
  }

  const needed = new Set(
    details.templates.flatMap(
      (template) => DFY_TEMPLATE_DETAIL_SECTIONS_MAP[template.type],
    ),
  );
  return Array.from(needed);
}
